import { render, staticRenderFns } from "./session-attendee-modal.vue?vue&type=template&id=777b0910&scoped=true&"
import script from "./session-attendee-modal.vue?vue&type=script&lang=ts&"
export * from "./session-attendee-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b0910",
  null
  
)

export default component.exports